'use strict';

// MODULES //

var objectKeys = require( 'object-keys' );


// TYPED ARRAY FUNCTIONS //

/**
* Create functions for copying typed arrays.
*/
var typedArrays = {
	'Int8Array': null,
	'Uint8Array': null,
	'Uint8ClampedArray': null,
	'Int16Array': null,
	'Uint16Array': null,
	'Int32Array': null,
	'Uint32Array': null,
	'Float32Array': null,
	'Float64Array': null
};

(function createTypedArrayFcns() {
	/* jshint evil:true */
	var keys = objectKeys( typedArrays );
	var len = keys.length;
	var key;
	var i;
	for ( i = 0; i < len; i++ ) {
		key = keys[ i ];
		typedArrays[ key ] = new Function( 'arr', 'return new '+key+'( arr );' );
	}
})();


// EXPORTS //

module.exports = typedArrays;



//////////////////
// WEBPACK FOOTER
// ./~/utils-copy/lib/typedarrays.js
// module id = 2079
// module chunks = 0